
<fieldmagic-dialog
    [icon]="[{
        icon: 'file-alt',
        variant: 'regular'
    }]"
    [label]="arFileDetails | data_get: 'file_name'"
>
  <ng-template fieldmagicDialogButtonsTmp>
    <fieldmagic-primary-button
        purpose="save"
        (click)="onSave()"
    ></fieldmagic-primary-button>

    <fieldmagic-dialog-close-button
        (click)="onClose()"
    ></fieldmagic-dialog-close-button>
  </ng-template>

  <ng-template fieldmagicDialogContentTmp>
    <div class="body" *ngIf="arVersionList != undefined">
        <div class="row label">
            <div class="col-sm-3">
                {{ 'version' | translate }}
            </div>
            <div class="col-sm-3">
                {{ 'file_size' | translate }}
            </div>
            <div class="col-sm-6">
                {{ 'updated_at' | translate }}
            </div>
        </div>
        <div *ngFor="let strVersion of arVersionList; let i = index">
            <div class="row data">
                <div class="col-sm-3">
                    {{ i + 1 }}
                </div>
                <div class="col-sm-3">
                    {{ formatFileSize(strVersion.size) }}
                </div>
                <div class="col-sm-6">
                    {{ formatDate(strVersion.date_updated) }}
                </div>
            </div>
        </div>
    </div>
    <hr class="separator"/>
    <div class="col-sm-12">
        <form [formGroup]="fileUploadForm" (ngSubmit)="onSubmit()">
            <drag-and-drop-file-upload-input [multiple]="false" formControlName="file"></drag-and-drop-file-upload-input>
        </form>

        <div class="mt-4"
            *ngIf="moduleName === 'jobs'"
        >
        <fieldmagic-checkbox-input
            [(ngModel)]="includeInJobReport"
            label="Include in Job Report"
            tooltip="This will only work for photos/images."
        ></fieldmagic-checkbox-input>
        </div>
    </div>
  </ng-template>
</fieldmagic-dialog>
